
<div mat-dialog-title class="red">Delete Securities<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
  <div>
    <table>
      <tr>
        <td style="vertical-align: top;">
          <span class="material-icons red" style="font-size: 36px;">delete_forever</span>
        </td>
        <td>
          @if (deleteSecurities) {
            <div style="margin-bottom: 10px;"><strong>{{deleteSecurities.length}} securities will be deleted and removed from your Security Inventory</strong></div>
          }
        </td>
      </tr>
    </table>
  </div>
  <div>
    <table width="100%">
      <tr>
        <td style="vertical-align: top; width: 72px; padding: 10px 0;"><strong>Securities</strong></td>
        <td style="padding: 10px; background-color: #fad1cf;">
          <div id="selectedSecuritiesModels"
            style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
            @if (deleteSecurities && deleteSecurities.length > 0) {
              <table id="deleteSecurities" style="width:100%; table-layout: fixed;">
                @for (securities of deleteSecurities; track securities) {
                  <tr>
                    <td style="width: 10%; vertical-align: top;">
                      <div class="truncate" tooltip [tooltipTitle]="securities.securitySymbol" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{securities.securitySymbol}}</div>
                    </td>
                    <td style="width: 50%; vertical-align: top;">
                      <div class="truncate" tooltip [tooltipTitle]="securities.securityDescription" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{securities.securityDescription}}</div>
                    </td>
                  </tr>
                }
              </table>
            }
          </div>
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>


<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
  <button mat-button class="btn-medium-primary red" (click)="deleteSelectedSecurities()"><span class="material-icons" style="font-size: 16px; margin-top: -3px;">delete_forever</span>&nbsp;Delete</button>
</mat-dialog-actions>
